// "Max producible" math — TRS §6.3.
//
//   maxProducible = floor(min over BOM (available[component] / qtyRequired))
//
// In v1 the catalogue treats listed components as leaves; multi-level
// resolution lands in v2. The schema permits a `productSku` to be referenced
// as a component (subassembly), but this function does NOT recurse — it
// reads the stock map exactly as supplied by the caller.
export function maxProducible(input) {
    if (input.bom.length === 0)
        return { units: 0, bottlenecks: [] };
    let minUnits = Number.POSITIVE_INFINITY;
    const bottlenecks = [];
    for (const line of input.bom) {
        if (!Number.isFinite(line.qtyRequired) || line.qtyRequired <= 0) {
            // Defensive: a 0-qty BOM line is meaningless. Treat as a bottleneck so
            // the operator notices.
            return { units: 0, bottlenecks: [line.componentSkuId] };
        }
        const have = input.available[line.componentSkuId] ?? 0;
        const possible = Math.floor(have / line.qtyRequired);
        if (possible < minUnits) {
            minUnits = possible;
            bottlenecks.length = 0;
            bottlenecks.push(line.componentSkuId);
        }
        else if (possible === minUnits) {
            bottlenecks.push(line.componentSkuId);
        }
    }
    return {
        units: Number.isFinite(minUnits) ? Math.max(0, minUnits) : 0,
        bottlenecks,
    };
}
export function lineStockChip(args) {
    if (args.available === undefined)
        return 'unknown';
    if (args.available >= args.required)
        return 'green';
    if (args.available > 0)
        return 'amber';
    return 'red';
}
//# sourceMappingURL=bom.js.map